<ndt-compact-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [hideHeader]="true"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="callerIdInformation" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="callerIdInformation-column-header">Caller Id</th>
            <td lcs-cell *lcsCellDef="let callParkingLots">
                  {{ callParkingLots.callerIdInformation }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="parkingSlotNumber" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="parkingSlotNumber-column-header">Parked In</th>
            <td lcs-cell *lcsCellDef="let callParkingLots">
                  {{ callParkingLots.parkingSlotNumber }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="parkerExtension" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="parkerExtension-column-header">Parked By</th>
            <td lcs-cell *lcsCellDef="let callParkingLots">
               <a [routerLink]="getRouterLink(callParkingLots.parkerExtension.extensionId)">
                  {{ callParkingLots.parkerExtension.number}} - {{callParkingLots.parkerExtension.name}}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="parkDateTime" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="parkDateTime-column-header">Time Parked</th>
            <td lcs-cell *lcsCellDef="let callParkingLots">
                  {{ callParkingLots.parkDateTime | date : 'h:mma' }}
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-compact-register-view>
